export default __webpack_public_path__ + "static/media/pp-light-2.450830d7.png";